import { Link } from "react-router";

const SIZZLE_HOME = "https://timetosizzle.com";

type BrandMarkProps = {
  to?: string;
  /** light = on dark/ink panels; dark = on paper (default marketing) */
  variant?: "light" | "dark";
  className?: string;
  /** In-app may omit endorsement (B-4.1); marketing default true */
  endorse?: boolean;
  /** "Sizzle" endorsement destination — defaults to TimeToSizzle.com */
  endorseHref?: string;
};

/** Brand lockup — SVG badge + linked "by Sizzle" endorsement (B-4.1) */
export function BrandMark({
  to = "/",
  variant = "dark",
  className = "",
  endorse = true,
  endorseHref = SIZZLE_HOME,
}: BrandMarkProps) {
  const onDark = variant === "light";
  return (
    <span className={`lockup ${className}`.trim()}>
      <Link to={to} className="lockup-home" aria-label="SchoolConferenceGo — home">
        <img
          src="/brand/SchoolConferenceGo.png"
          alt="SchoolConferenceGo by Sizzle"
          className="lockup-logo lockup-logo--badge"
          width={220}
          height={34}
          decoding="async"
        />
        <img
          src="/brand/SchoolConferenceGo-square.png"
          alt="SchoolConferenceGo"
          className="lockup-logo lockup-logo--square"
          width={32}
          height={32}
          decoding="async"
        />
      </Link>
      {endorse && (
        <a
          href={endorseHref}
          target="_blank"
          rel="noopener noreferrer"
          className="lockup-endorse lockup-endorse-link"
          style={onDark ? { color: "rgba(255,255,255,0.55)" } : undefined}
        >
          by Sizzle
        </a>
      )}
    </span>
  );
}
